export default {
	props: {
		numItems:{type:Number, default:0},
		breakpoints:{type:Array, default(){ return [{w:1024, cnt:3}, {w:680, cnt:2}];} },
	},
	data(){
		return {
			activeIndex: null,
			itemsOrder:[],
		};
	},
	methods: {
		calculateItemOrder(index) {
			let itemsPerRow = 1;
			for(const el of this.breakpoints){
				if(window.innerWidth>el.w){
					itemsPerRow = el.cnt;
					break;
				}
			}
			return Math.floor(index/itemsPerRow);
		},
		updateItemsOrdering() {
			let itemsOrder = [];
			for(let i=0;i<this.numItems;i++){
				itemsOrder[i] = this.calculateItemOrder(i);
			}
			this.itemsOrder = itemsOrder;
		},
		btnShow(i){ this.activeIndex = i; },
		btnHide(){ this.activeIndex = null; },
		btnToggleShowHide(i){
			this.activeIndex = this.activeIndex === i ? null : i;
		},
	},
	mounted() {
		window.addEventListener('resize', this.updateItemsOrdering);
		this.updateItemsOrdering();
	},
	destroyed(){
		window.removeEventListener('resize', this.updateItemsOrdering);
	},
	template: `
<div class="qit-reordering-container">
	<slot v-bind="{btnShow,btnHide,btnToggleShowHide,itemsOrder,activeIndex}">
	</slot>
</div>
`,
}
